var _path, _path2, _rect, _rect2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _path10, _ellipse2, _path11, _path12, _path13, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtVote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 170,
    viewBox: "0 0 206 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 29V149",
    stroke: "#0F214F",
    strokeDasharray: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89.3428H161",
    stroke: "#0F214F",
    strokeDasharray: 8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 60,
    width: 81,
    height: 9,
    fill: "#0F214F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2137_1202",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 69,
    height: 69
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 69,
    height: 69,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2137_1202)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 47.5,
    r: 33.0625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 47.5,
    r: 32.5625,
    stroke: "#0F214F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.2188,
    cy: 48.2188,
    r: 25.1562,
    fill: "#77DDFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0361 38.0361V42.0204H44.2955L31.0691 55.2467L34.1905 58.368L47.4165 45.1417V58.4007H51.4007V42.0204V38.0361H31.0361Z",
    fill: "#0F214F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 152C29 148.686 26.3137 146 23 146H11C7.68629 146 5 148.686 5 152V164C5 167.314 7.68629 170 11 170H29V152Z",
    fill: "#77DDFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9997 159.363L14.1966 162.166L12.833 160.803L15.6361 158L12.833 155.197L14.1966 153.833L16.9997 156.636L19.8028 153.833L21.1663 155.197L18.3633 158L21.1663 160.803L19.8028 162.166L16.9997 159.363Z",
    fill: "#0F214F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 122C33 115.373 38.3726 110 45 110H69C75.6274 110 81 115.373 81 122V146C81 152.627 75.6274 158 69 158H33V122Z",
    fill: "#0F214F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 129.017L64.0863 126L54.4246 136.006L49.9137 131.334L47 134.352L54.4246 142L67 129.017Z",
    fill: "#EBF7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172 111C172 106.582 175.582 103 180 103H188C192.418 103 196 106.582 196 111V119C196 123.418 192.418 127 188 127H172V111Z",
    fill: "#77DDFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 121.312C187.21 121.312 189.812 118.71 189.812 115.5C189.812 112.29 187.21 109.688 184 109.688C180.79 109.688 178.188 112.29 178.188 115.5C178.188 118.71 180.79 121.312 184 121.312ZM187.534 117.973L181.527 111.966C183.172 110.809 185.516 110.918 187.049 112.451C188.583 113.985 188.69 116.329 187.534 117.973ZM180.466 113.027C179.31 114.671 179.417 117.015 180.951 118.549C182.484 120.082 184.828 120.191 186.473 119.034L180.466 113.027Z",
    fill: "#0F214F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.212 155.75C157.213 155.75 158.951 154.373 159.41 152.425L161.791 142.303C162.044 141.228 162.25 139.458 162.25 138.353V124.844C162.25 122.882 160.679 121.288 158.726 121.251C156.712 121.212 155.062 122.9 155.062 124.915V132.75H154.344V116.919C154.344 114.903 152.694 113.216 150.68 113.255C148.727 113.292 147.156 114.886 147.156 116.848V132.75H146.437V113.415C146.437 111.4 144.788 109.712 142.773 109.751C140.821 109.788 139.25 111.382 139.25 113.344V132.75H138.531V117.008C138.531 114.993 136.882 113.306 134.867 113.344C132.915 113.382 131.344 114.976 131.344 116.938V138.14L128.5 134.23C127.333 132.625 125.085 132.27 123.48 133.437C121.875 134.605 121.52 136.852 122.688 138.457L133.972 153.974C134.685 154.954 136.247 155.75 137.46 155.75H155.212Z",
    fill: "#0F214F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187,
    cy: 30.6111,
    rx: 6.65,
    ry: 6.61111,
    fill: "#77DDFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206 58.0002C206 47.5682 197.493 39.1113 187 39.1113C176.507 39.1113 168 47.5682 168 58.0002",
    fill: "#77DDFB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141,
    cy: 30.6111,
    rx: 6.65,
    ry: 6.61111,
    fill: "#77DDFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 58.0002C160 47.5682 151.493 39.1113 141 39.1113C130.507 39.1113 122 47.5682 122 58.0002",
    fill: "#77DDFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.95 29.5278C172.95 34.5176 168.939 38.5556 164 38.5556C159.061 38.5556 155.05 34.5176 155.05 29.5278C155.05 24.538 159.061 20.5 164 20.5C168.939 20.5 172.95 24.538 172.95 29.5278Z",
    stroke: "#0F214F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M164 42.2773C178.466 42.2773 190.231 53.9683 190.495 68.4996H137.505C137.769 53.9683 149.534 42.2773 164 42.2773Z",
    stroke: "#0F214F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 102,
    width: 2,
    height: 6,
    transform: "rotate(30 82 102)",
    fill: "#0F214F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89.877,
    y: 110.284,
    width: 2,
    height: 6,
    transform: "rotate(76 89.877 110.284)",
    fill: "#0F214F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtVote);
export default __webpack_public_path__ + "static/media/art-vote.7e7589adc8ed57b8dd4f44be4829dd7f.svg";
export { ForwardRef as ReactComponent };